const FooterSignIn = () => {
  return (
    <footer className="auth-footer font-black theme-text fw-400">
      {/* {t('Never_sign_in_at_the_behest')} <br />
      <a href="http://correcto.io">{t('Find_our_answers_here')}</a> */}
      Logga aldrig in på uppdrag av någon som kontaktar dig. Har du några frågor? <br />
      <a href="http://correcto.io">Hitta våra svar här</a>
    </footer>
  )
}

export default FooterSignIn